(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  function initCountdownTimers(container = document) {
    const countdownRows = container.querySelectorAll('[data-countdown-date]');
    countdownRows.forEach((row) => {
      // Skip if already initialized
      if (row.dataset.countdownInitialized) {
        return;
      }
      row.dataset.countdownInitialized = 'true';

      const countdownDate = row.getAttribute('data-countdown-date');
      const timerElement = row.querySelector('[data-countdown-timer]');

      if (countdownDate && timerElement) {
        startCountdown(countdownDate, timerElement, row);
      }
    });
  }

  function startCountdown(targetDate, timerElement, row) {
    // Normalize date format - if only date is provided, add end of day time
    let normalizedDate = targetDate.trim();
    if (normalizedDate && !normalizedDate.includes('T')) {
      normalizedDate = normalizedDate + 'T23:59:59';
    }

    const updateCountdown = () => {
      try {
        const now = new Date().getTime();
        const target = new Date(normalizedDate).getTime();

        if (isNaN(target)) {
          timerElement.textContent = '';
          return;
        }

        const distance = target - now;

        if (distance < 0) {
          timerElement.textContent = '';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        let countdownText = '';
        if (days > 0) {
          countdownText += `${days}d `;
        }
        if (hours > 0 || days > 0) {
          countdownText += `${hours}h `;
        }
        if (minutes > 0 || hours > 0 || days > 0) {
          countdownText += `${minutes}m `;
        }
        countdownText += `${seconds}s`;

        timerElement.textContent = countdownText;
      } catch (e) {
        console.error('Countdown error:', e);
        timerElement.textContent = '';
      }
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }

      // Initialize countdown timers
      initCountdownTimers(this);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  // Fallback initialization for theme editor and regular page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCountdownTimers();
    });
  } else {
    initCountdownTimers();
  }

  // Also initialize on theme editor updates
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      initCountdownTimers(event.detail.container || event.target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open') ? this.close() : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
      }

      handleClick(e) {
        e.preventDefault();
        const { closeAnnouncement } = e.target.dataset;
        if (closeAnnouncement === 'row') {
          e.target.closest('.announcement-bar__row').remove();
        } else {
          this.remove();
        }
      }

      connectedCallback() {
        if (this.querySelector('.announcement-bar__close')) {
          this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
        }
      }
    }

    customElements.define('announcement-bar', AnnouncementBar);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
